export function sendLog(props){

  const eventName = props.event_type;
  const eventData = Object.keys(props).filter(key =>
    key !== 'event_type' &&
    key !== 'elementType' &&
    key !== 'action' &&
    (key !== 'component_type' || props['event_type'] === 'sim_log_impression') &&
    (key !== 'component_id' || props['event_type'] === 'sim_log_impression')
    ).reduce((obj, key) =>
    {
        obj[key] = props[key];
        return obj;
    }, {}
  );

  // alert(JSON.stringify({
  //   type: 'analytics',
  //   eventName: eventName,
  //   eventData: eventData,
  // }))

  // window.parent.postMessage({ 
  //     method: 'event',
  //     data: {
  //         type: 'analytics',
  //         eventName: eventName,
  //         eventData: eventData,
  //     }
  // }, '*'); 
}
